import { Instance } from 'mobx-state-tree';
import model from './model';
import actions from './actions';

const Auth = model.actions(actions);

export interface IAuthStore extends Instance<typeof Auth> {}

export default Auth;
